import React from 'react';
import type { Feature, Page } from '../types';

interface FeatureCardProps {
  feature: Feature;
  onFeatureClick: (page: Page) => void;
  disabled: boolean;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ feature, onFeatureClick, disabled }) => {
  const Icon = feature.icon;
  const isClickable = !!feature.pageLink && !disabled;

  const content = (
    <>
      <div className={`p-4 rounded-lg mb-4 ${disabled ? 'bg-gray-100' : 'bg-pink-100'}`}>
        <Icon className={`w-8 h-8 ${disabled ? 'text-gray-400' : 'text-pink-500'}`} />
      </div>
      <h3 className={`text-lg font-bold mb-2 ${disabled ? 'text-gray-500' : 'text-gray-800'}`}>{feature.title}</h3>
      <p className="text-gray-600 text-sm">{feature.description}</p>
    </>
  );

  if (isClickable) {
    return (
      <button
        onClick={() => onFeatureClick(feature.pageLink!)}
        className="w-full h-full bg-white p-6 rounded-lg shadow-md hover:shadow-xl hover:scale-105 transition-all duration-300 flex flex-col items-center text-center focus:outline-none focus:ring-2 focus:ring-pink-500"
        aria-label={`Go to ${feature.title}`}
      >
        {content}
      </button>
    );
  }

  return (
    <div className={`bg-white p-6 rounded-lg shadow-md flex flex-col items-center text-center ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`}>
      {content}
    </div>
  );
};

export default FeatureCard;